/**
 * Yandex blocks the production domain from loading its Maps JS SDK directly
 * (`api-maps.yandex.ru`), so instead of embedding `@pbe/react-yandex-maps`
 * on this origin, every map on this site is rendered inside an <iframe>
 * pointed at a small map micro-app hosted on a domain Yandex hasn't blocked.
 * Parent <-> iframe talk over `window.postMessage` using the protocol below.
 *
 * This mirrors the workaround already shipped in the sibling `yapona` repo
 * (`src/components/UI/MapDialog/utils/{constants,useMapDialog}.js`), reusing
 * the same external widget at `auth.delever.uz/map`.
 */

export const MAP_DOMAIN =
  process.env.NEXT_PUBLIC_MAP_DOMAIN || 'https://auth.delever.uz'

export const MESSAGE_TYPES = {
  MAP_CLICK: 'MAP_CLICK',
  MARKER_SELECTED: 'MARKER_SELECTED',
  ADDRESS_RESOLVED: 'ADDRESS_RESOLVED',
  MAP_READY: 'MAP_READY',
  SET_CENTER: 'SET_CENTER',
  ADD_MARKER: 'ADD_MARKER',
  SET_MARKERS: 'SET_MARKERS',
  SELECT_MARKER: 'SELECT_MARKER',
  CLEAR_MARKERS: 'CLEAR_MARKERS',
  GET_ADDRESS: 'GET_ADDRESS',
  /** Outbound: the widget finished a drag/pan and settled on a new center. */
  BOUNDS_CHANGED: 'BOUNDS_CHANGED',
  /** Inbound: draw delivery-zone polygons on the map. */
  SET_ZONES: 'SET_ZONES',
  /** Inbound: remove all delivery-zone polygons. */
  CLEAR_ZONES: 'CLEAR_ZONES',
} as const

export type MapMessageType =
  (typeof MESSAGE_TYPES)[keyof typeof MESSAGE_TYPES]

export const DELIVERY_MARKER_ID = 'delivery-marker'

export const MAP_MODES = {
  DELIVERY: 'delivery',
  SELF_PICKUP: 'self-pickup',
} as const
